// Utils
import getIn from '@shopee/get-in';
// Constants
import { REDUCER_NAME } from './constants';
export const getCatalogueInfo = (state, username) => getIn(state, [REDUCER_NAME, username, 'data']);
export const getCatalogueInfoApiProgress = (state, username) => getIn(state, [REDUCER_NAME, username, 'progress'], 0 /* Init */);
export const getCatalogueInfoError = (state, username) => getIn(state, [REDUCER_NAME, username, 'error']);
export const getServerRendered = (state, username) => getIn(state, [REDUCER_NAME, username, 'serverRendered'], false);
